import React from 'react';

const AddressFields = ({ formData, handleInputChange }) => {
  return (
    <div>
      <div className="form-group inline">
        <div>
          <label htmlFor="street">Straße <span className="optional">(Optional)</span></label>
          <input type="text" id="street" name="street" value={formData.street} onChange={handleInputChange} />
        </div>
        <div>
          <label htmlFor="house-number">Hausnummer <span className="optional">(Optional)</span></label>
          <input type="text" id="house-number" name="houseNumber" value={formData.houseNumber} onChange={handleInputChange} />
        </div>
      </div>

      <div className="form-group inline">
        <div>
          <label htmlFor="city">Stadt</label>
          <input type="text" id="city" name="city" value={formData.city} onChange={handleInputChange} required />
        </div>
        <div>
          <label htmlFor="postal-code">Postleitzahl</label>
          <input type="text" id="postal-code" name="postalCode" value={formData.postalCode} onChange={handleInputChange} required />
        </div>
      </div>
    </div>
  );
};

export default AddressFields;
